import { buildAbsoluteLegalUrls } from '@nebalkon-workspace/cabinet-core';
import { environment } from '@nebalkon-workspace/environments';

const legalUrls = buildAbsoluteLegalUrls(environment.productionSiteUrl);

/** Хаб правовых документов на сайте. */
export const LEGAL_HUB_URL = legalUrls.hub;

/** Политика по обработке персональных данных (чекбоксы согласия в формах). */
export const LEGAL_PRIVACY_POLICY_URL = legalUrls.privacyPolicy;

/** Пользовательское соглашение. */
export const LEGAL_USER_AGREEMENT_URL = legalUrls.userAgreement;

/** Договор публичной оферты. */
export const LEGAL_PUBLIC_OFFER_URL = legalUrls.publicOffer;

/** Публичная страница удаления аккаунта (требование Google Play). */
export const LEGAL_ACCOUNT_DELETION_URL = legalUrls.accountDeletion;
